import { Button, Card, CardContent, PageHeader } from '@bemor/web-kit/ui';
import { useCallback, useEffect, useRef, useState } from 'react';

import { handoff } from '@/lib/handoff';

/**
 * `/ledger` (BM-109, C2 and C3): "Open Ledger" in the nav is a hand-off, never a plain link. Identity opens the
 * board's own Ledger: this tenant's board from a tenant host, the platform's Ledger host from the platform host (no
 * tenant named either way; the session decides). The browser leaves for it; a refusal stays here with Retry.
 */
export function LedgerBridgePage() {
    const [error, setError] = useState<string | null>(null);
    // one hand-off per visit: the effect runs twice under StrictMode and each call mints a session and a grant
    const started = useRef(false);
    const open = useCallback(async () => {
        setError(null);
        const url = await handoff(null, 'ledger').catch(() => null);
        if (url) {
            window.location.assign(url);
            return;
        }
        setError('Ledger could not be opened. Try again.');
    }, []);
    useEffect(() => {
        if (started.current) return;
        started.current = true;
        // the hand-off is the page's one job; its answer lands asynchronously
        // eslint-disable-next-line react-hooks/set-state-in-effect
        void open();
    }, [open]);
    return (
        <div data-testid="ledger-bridge">
            <PageHeader
                title="Opening Ledger"
                meta="Your session carries over to the Ledger board."
            />
            <Card className="max-w-lg">
                <CardContent className="space-y-3 pt-6 text-sm">
                    {error ? (
                        <>
                            <p role="alert" className="text-destructive">
                                {error}
                            </p>
                            <Button
                                variant="outline"
                                onClick={() => void open()}
                            >
                                Retry
                            </Button>
                        </>
                    ) : (
                        <p className="text-muted-foreground">One moment.</p>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}
